import { useNavigate } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { useSessionExpired } from "../lib/authState";
import { useOutbox } from "../lib/outbox";

export const SessionExpiredBanner = () => {
  const expired = useSessionExpired();
  const { items } = useOutbox();
  const navigate = useNavigate();
  if (!expired) return null;
  const n = items.filter((i) => i.sync_state !== "failed").length;
  return (
    <div className="banner-warn session-banner" data-testid="session-expired-banner">
      <KeyRound size={16} />
      <span className="flex-1">Session expired — sign in again{n ? ` to sync your ${n} queued job${n === 1 ? "" : "s"}` : ""}.</span>
      <button type="button" className="balance-pill" onClick={() => navigate("/auth?reason=expired")} data-testid="session-expired-signin">Sign in</button>
    </div>
  );
};
